import {Routes} from '@angular/router';
import {SubscriptionV2Component} from '../components/subscription-v2/subscription-v2.component';
import {blank} from '../../common/strings';
import {SubV2WhoComponent} from '../components/subscription-v2/sub-v2-who/sub-v2-who.component';
import {SubV2SearchComponent} from '../components/subscription-v2/sub-v2-search/sub-v2-search.component';
import {SubV2FinalizeComponent} from '../components/subscription-v2/sub-v2-finalize/sub-v2-finalize.component';
import {SubV2PayComponent} from '../components/subscription-v2/sub-v2-pay/sub-v2-pay.component';
import {SubV2ThanksComponent} from '../components/subscription-v2/sub-v2-thanks/sub-v2-thanks.component';

const subscriptionCompletionComponent = () => import('../components/subscription-completion/complete-subscription.component').then(m => m.SubscriptionCompletionComponent)
const subscriptionV2EditComponent = () => import('../components/subscription-v2/sub-v2-edit/sub-v2-edit.component').then(m => m.SubV2EditComponent)
const resultComponent = () => import('../components/session/result/result.component').then(m => m.ResultComponent)
const confirmComponent = () => import('../components/session/confirm/confirm.component').then(m => m.ConfirmComponent)
const cancelComponent = () => import('../components/session/cancel/cancel.component').then(m => m.CancelComponent)
const payComponent = () => import('../components/session/pay/pay.component').then(m => m.PayComponent)

export const subscriptionRoutes: Routes = [

  { path: 'subscribe-v2/:sessionId',
    component: SubscriptionV2Component,
    children: [
      { path: blank, redirectTo: 'who', pathMatch: 'full' },
      { path: 'who', component: SubV2WhoComponent, pathMatch: 'full', title: 'Mes informations' },
      { path: 'search', component: SubV2SearchComponent, pathMatch: 'full', title: 'Ma recherche' },
      { path: 'finalize', component: SubV2FinalizeComponent, pathMatch: 'full', title: 'Finalisation' },
      { path: 'pay', component: SubV2PayComponent, pathMatch: 'full', data : { seo:  { title: "7 minutes pour toi | Paiment de ton billet", url: "pay"}}},
      { path: 'thanks', component: SubV2ThanksComponent, pathMatch: 'full', title: 'Merci !' },
    ]
  },

  { path: 'subscribe/:sessionId/edit/:subscriptionId/phoneNumber/:phoneNumber', loadComponent: subscriptionV2EditComponent},
  { path: 'complete/:sessionId/:subscriptionId/phoneNumber/:phoneNumber', loadComponent: subscriptionCompletionComponent,
    loadChildren: () => import("./subscription.completion.routes").then(m => m.subscriptionCompletionRoutes)
  },
  { path: 'result/:sessionId/:subscriptionId/phoneNumber/:phoneNumber', loadComponent: resultComponent },
  { path: 'confirm/:sessionId/:subscriptionId/phoneNumber/:phoneNumber', loadComponent: confirmComponent },
  { path: 'cancel/:sessionId/:subscriptionId/phoneNumber/:phoneNumber', loadComponent: cancelComponent },
  { path: 'pay/:sessionId', loadComponent: payComponent },
  { path: 'pay', loadComponent: payComponent,
    data : { seo:  { title: "7 minutes pour toi | Paiment de ton billet", url: "pay"}}
  },
]
